import { render, staticRenderFns } from "./GenericError.vue?vue&type=template&id=456d4e39&scoped=true"
import script from "./GenericError.vue?vue&type=script&lang=js"
export * from "./GenericError.vue?vue&type=script&lang=js"
import style0 from "./GenericError.vue?vue&type=style&index=0&id=456d4e39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d4e39",
  null
  
)

export default component.exports